export const isFieldEmpty = (field?: string | number | null) =>
  field === '' || field === null || field === undefined;

export const isNumber = (value: number | undefined) =>
  typeof value === 'number';
